import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import MediaQuery from 'react-responsive'
import { DoubleBounce } from 'better-react-spinkit'

import BookingCalendar from './BookingCalendar'
import ActiveBookings from './ActiveBookings'
import Hotels from './Hotels'
import { withCookies, Cookies } from 'react-cookie';

import { SpinnerWrapper } from '../GeneralStyle'

@inject('golfCourseStore')

@observer
class Bookings extends Component {

  constructor(props) {
    super(props);

    this.setHotelRef = element => {
      this.hotels = element;

      this.scroll()
    };
  }

  componentWillMount() {
    this.props.golfCourseStore.getGolfCourses()
  }

  componentWillUpdate() {
    // if(!this.props.golfCourseStore.isGolfCourseData || !this.hotels)
    //   return
    // this.scroll()
  }

  scroll = () => {
    if(this.props.match.params.target != "hotels")
      return

    const elem = ReactDOM.findDOMNode(this.hotels)
    if(elem){
      elem.scrollIntoView({block: 'start'})
      setTimeout(() => {
        window.scrollBy(0,window.innerHeight/2 - 50)
      }, 500);
    }
  }

  render() {
    const { isGolfCourseData } = this.props.golfCourseStore

    return (
      <div>
        {!isGolfCourseData
          ? <SpinnerWrapper>
              <DoubleBounce color={"#DAB777"} size={60}/>
            </SpinnerWrapper>
          :
          <div style={{maxWidth: 1200, margin: "45px auto"}}>
            <MediaQuery query="(min-device-width: 1200px)">
              <BookingCalendar />
              <Hotels inline ref={this.setHotelRef}/>
              <ActiveBookings />
            </MediaQuery>
            <MediaQuery query="(max-device-width: 1199px)">
              <ActiveBookings />
              <BookingCalendar />
              <Hotels inline ref={this.setHotelRef}/>
            </MediaQuery>
          </div>
        }
      </div>
    )
  }
}

Bookings.propTypes = {
  golfCourseStore: MobxPropTypes.observableObject
}

export default Bookings



// WEBPACK FOOTER //
// /src/components/internal/Bookings.js